import i18nFactory from '@yandex-int/i18n';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { Action } from '../../actions';
import { LOAD_BANNERS_PREVIEW, LoadBannersPreviewAction, updateBannersPreview } from '../../actions/banners-preview';
import { selectGridAdditionalFilter } from '../../selectors/grid/grid';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import '../../service/Rx';
import { EpicDeps } from '../../service/StoreFactory';
import { banners } from '../../typings/common';
import { Banner } from '../../typings/domain';
import { State } from '../../typings/state';

import * as keyset from './bannersPreview.i18n';

const i18n = i18nFactory(keyset);

const loadBannersPreviewEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(LOAD_BANNERS_PREVIEW),
        mergeMap(
            (action: LoadBannersPreviewAction): Observable<Action> => {
                const state = store$.value;
                const { clientInfo } = state.grid;
                const { features } = state.commonData;
                const additionalFilter = selectGridAdditionalFilter(state);
                const sourceParams = selectGridSourceParams(state);

                return from(
                    deps.entitiesDataProvider.getBannersPreview(
                        {
                            ...sourceParams,
                            view: banners,
                            additionalFilter: additionalFilter ? additionalFilter.additionalFilterValue : undefined
                        },
                        clientInfo,
                        features,
                        [action.campaignId],
                        [action.groupId]
                    )
                ).pipe(
                    map(
                        (bannerItems: Banner[]): Action => {
                            return updateBannersPreview({
                                [action.groupId]: {
                                    banners: bannerItems
                                }
                            });
                        }
                    ),
                    catchError(
                        (): Observable<Action> => {
                            return of(
                                updateBannersPreview({
                                    [action.groupId]: {
                                        error: i18n('failed-to-load-banners-for-popup')
                                    }
                                })
                            );
                        }
                    )
                );
            }
        )
    );
};

export { loadBannersPreviewEpic };
